var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "webContent flex",
      attrs: { scroll: "" },
      on: { scroll: _vm.listenScroll }
    },
    [
      _c("div", { staticClass: "home" }, [
        _c("div", { staticClass: "banner" }, [
          _c("div", { staticClass: "uname" }, [
            _vm._v(
              "Hi, " +
                _vm._s(_vm.user.name) +
                "（" +
                _vm._s(_vm.user.mapperNumber) +
                "）"
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "point" }, [
            _vm._v("积分：" + _vm._s(_vm.point))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "search df" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.searchVal,
                  expression: "searchVal"
                }
              ],
              staticClass: "flex",
              attrs: { puc: "", type: "text", placeholder: "搜索" },
              domProps: { value: _vm.searchVal },
              on: {
                keyup: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.search.apply(null, arguments)
                },
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.searchVal = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "btn", on: { click: _vm.search } })
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "balloon anim_fade_image",
              staticStyle: { display: "none" }
            },
            [_vm._v("+" + _vm._s(_vm.integration))]
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "car-compare", on: { click: _vm.toCarCompare } },
          [_vm._v("车型对比")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "list" }, [
          _c(
            "div",
            {
              staticClass: "li",
              class: { open: _vm.isOpen.model },
              on: {
                click: function($event) {
                  return _vm.openLi("model", $event.currentTarget)
                }
              }
            },
            [_vm._v(_vm._s(_vm.modelName))]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isOpen.model,
                  expression: "isOpen.model"
                }
              ],
              staticClass: "content model",
              class: { show: _vm.isOpen.model }
            },
            _vm._l(_vm.model, function(v, i) {
              return _c(
                "div",
                {
                  key: i,
                  staticClass: "item",
                  style: "background-image: url(" + (v.imageUrl || "") + ");",
                  on: {
                    click: function($event) {
                      return _vm.toList("model", v)
                    }
                  }
                },
                [_c("i", [_vm._v(_vm._s(_vm.replaceAll(v.name)))])]
              )
            }),
            0
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "answer" }, [
          _c("div", { staticClass: "answer-cap" }, [_vm._v("最新解答")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "answer-list" },
            _vm._l(_vm.answer, function(v, i) {
              return _c(
                "div",
                {
                  key: i,
                  staticClass: "answer-li",
                  on: {
                    click: function($event) {
                      return _vm.toDetail(v)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "answer-title" }, [
                    v.announcement == 1
                      ? _c("i", { staticClass: "rule" })
                      : _vm._e(),
                    v.refining == 1
                      ? _c("i", { staticClass: "prize" })
                      : _vm._e(),
                    v.top == 1 ? _c("i", { staticClass: "top" }) : _vm._e(),
                    _vm._v(_vm._s(v.title))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "answer-tool df" }, [
                    _c("div", { staticClass: "flex" }, [
                      _vm._v(
                        _vm._s(
                          v.answerTotal > 0
                            ? v.answerTotal + "人回答"
                            : "暂无回答"
                        ) +
                          " · " +
                          _vm._s(
                            v.attentionTotal > 0
                              ? v.attentionTotal + "人关注"
                              : "暂无关注"
                          )
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("b", [
                        _vm._v(
                          _vm._s(v.creatorName || "") +
                            "（" +
                            _vm._s(v.creatorMapperNumber) +
                            "）"
                        )
                      ]),
                      _vm._v(_vm._s(_vm.dateTime(v.createTime)))
                    ])
                  ])
                ]
              )
            }),
            0
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-214fce57", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-214fce57","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/home/index/index.vue
// module id = null
// module chunks = 